export default {
  payChannel: 'Canales de pago',
  cashierDesk: 'Mostrador de caja',
  billAddress: 'Dirección de facturación',
  paySuccess: 'Pago exitoso',
  payError: 'Error de pago',
  harvestAddress: 'Dirección de envío',
  orderAddress: 'Dirección de facturación',
  selectAddress: 'Seleccione una dirección de envío',
  addOrderAddress: 'Por favor, agregue primero la dirección de facturación',
  addSelectAddress: 'Por favor, seleccione una dirección de envío',
  noAddress: 'No hay dirección de envío disponible',
  holder: {
    inputPayPwd: 'Por favor, establezca la contraseña de pago',
    returnExchange: 'Pago no completado. No se puede procesar la solicitud de devolución/cambio.',
  },
  transferTitle: 'Transferencia bancaria',
  changeAddress: 'Cambiar dirección',
  editText: 'Editar',
  payWithbalance: 'Pagar con el saldo de acbuy',
  bankTransferRemittance: 'Transferencia bancaria',
  transferTips:
    '0 tarifa de servicio en acbuy para remesas. ¡Cuanto mayor sea el monto del pedido, más ahorro!',
  pay: 'Ofertas de recarga',
  plsSetPsd: 'Por favor, establezca la contraseña de pago',
  thirdPayTips: 'Los pagos están disponibles en todo el mundo y en múltiples monedas',
  payProcessing: 'Procesando el pago',
  payWaitingText: 'Esperar de 1 a 2 minutos, por favor, consulte el resultado del pago más tarde',
  coinpalTips:
    'La recarga realizada mediante criptomonedas (monedas virtuales) no admite reembolsos ni retiros. Si está de acuerdo, por favor continúe con la recarga. ',
  payStatusTips: `Aún no hemos recibido el resultado de su pago. Por favor, confirme el estado de su pago.`,
  payErrorStatusTips: 'El pago ha fallado. Intente con otro método de pago.',
}
